const ExpensesAccountDetail = ({data, label, value, classes="", isDescription, children}) => {
    return (
    <div className={`expenses-account-detail d-flex ${classes} mb-2 ${isDescription && data.isMobile ? "flex-column" : ""}`}>
      <label className={` ${data.isMobile ? "text-left text-uppercase pl-0 mt-1 col-7" : "col-6 text-right"}`}>
        {label} :
      </label>
      <div className={`expenses-account-detail__value  ${data.isMobile ? "px-0" : "col-6"} ${isDescription && data.isMobile ? "mt-2" : ""}`}>
        { children  || <span>{value}</span>}
      </div>
    </div>
  );
};

export default ExpensesAccountDetail;
